module.exports = __webpack_public_path__ + "media/images/team/pete_falcone-5fbf58028fa4041fa8f7de8e19468ca3.png";